import { QueryClient, useQuery } from '@tanstack/react-query';
import teamService, { TeamListDto } from '../../services/teams/teamService';
import { TEAMS_STALE_TIME_MS, teamsQueryKeys } from './teamsQueryKeys';

/**
 * Lista de times via React Query.
 *
 * O `queryFn` reutiliza `teamService.getTeams()` (cache/dedup de 5 min + coalescência).
 * Não há segundo cache independente: o serviço é a camada HTTP; o RQ assina o resultado
 * e invalida a UI após mutações.
 */
export function useTeamsQuery(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: teamsQueryKeys.list(),
    queryFn: (): Promise<TeamListDto[]> => teamService.getTeams(),
    staleTime: TEAMS_STALE_TIME_MS,
    enabled: options?.enabled ?? true,
  });
}

export function invalidateTeamsQueries(queryClient: QueryClient): Promise<void> {
  teamService.invalidateTeamsCache();
  return queryClient.invalidateQueries({ queryKey: teamsQueryKeys.all() });
}
